import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

export const mediaUrl = (path) => (path ? `${BACKEND_URL}${path}` : "");

export default api;
